import t from"react";import{MdIcon as e}from"./MdIcon.js";import{mdiMenu as m}from"@mdi/js";const o=({id:o="menu",title:r="Menu",...i})=>t.createElement(e,{id:o,title:r,path:m,...i});export{o as MenuIcon};
